import React, { useCallback, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { deleteCard } from "../../../../sevices/apiCards";
import { useSearchParams } from "react-router-dom";
import { useResponsive } from "../../../../hooks/useResponsive";
import { Tooltip, Typography } from "@mui/material";
import { TooltipName } from "../../../../utils/Enums";
import { DeleteIcone } from "../../../../components/UI/Icons";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useMutate from "../../../../hooks/useMutate";

const DeleteCard = ({
  cardId,
  boardId,
  kanbanCardDelete,
  setShowDetails,
  className = "",
  DeleteIconStyle = "",
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isMobile = useResponsive("down", "md");
  const queryClient = useQueryClient();
 
  const { mutate: deleteCardMutate } = useMutate(deleteCard,
    ['mineCards', 'watching'],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, boardId],
      });
      setLoading(false);
      searchParams.delete("card_id");
      setSearchParams(searchParams);
      setShowDelete(false);
      setShowDetails(false);
    },
    () => {
      setLoading(false);
      setShowDelete(false);
    },
  );

  const callback = useCallback((e) => {
    setLoading(true);
    deleteCardMutate(cardId);
  }, [cardId, deleteCardMutate]);

  const handleCardDelete = useCallback((e) => {
    e.stopPropagation();
    setShowDelete(true);
  }, []);

  const handleClose = useCallback((e) => {
    e.stopPropagation();
    setShowDelete(false);
  }, []);

  return (
    <span className={`d-flex align-items-center  ${className}`}>
      {showDelete && (
        <FormDialog
          open={showDelete}
          handleClose={handleClose}
          loading={loading}
          handleSubmit={callback}
          buttonTxt="Delete"
          title="Confirmation: Delete Task"
          alignActions="center"
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure you want to delete this item? This action cannot be
            undone.
          </Typography>
        </FormDialog>
      )}
      {isMobile ? (
        <>
          <Typography
            className={"workflow_steps d-flex align-items-center delete-card"}
            onClick={(e) => {
              e.stopPropagation();
              handleCardDelete(e);
            }}>
            <DeleteIcone className={"delete-card-button mr-2"} />
            Delete Card
          </Typography>
        </>
      ) : (
        <Tooltip title={TooltipName.KANBAN_CARD.DELETE_THIS_TASK}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              handleCardDelete(e);
            }}
            className={kanbanCardDelete ? "delete-card" : "delete-card-button"}>
            <DeleteIcone className={DeleteIconStyle} />
          </div>
        </Tooltip>
      )}
    </span>
  );
};

export default React.memo(DeleteCard);
